module.exports = __webpack_public_path__ + "img/card-budget-hover.3fda3bfc.svg";